/**
 * Wf相关常量
 */
export class WfConstants {
    static getBasePath() {
        try {
            return (window as any).gspframeworkService.common.getBasePath.get();
        } catch (error) {
        }
    }
    static PF_CMP_ID1 = '7433df25-9260-4c24-86f0-9da3e89450fb';
    static PF_CMP_ID2 = 'd0783800-ed60-488c-b053-8806a15947fe';
    static PF_CMP_ID3 = 'b89e9b9a-2e2d-4bd0-b354-187219544d34';
    static PF_CMP_ID4 = 'a8b8f7a4-49ae-4b7d-88d2-b3772b9d0ae5';
    static IMAGE_PATH = WfConstants.getBasePath() + "/platform/runtime/common/web/@gsp-wf/wf-process-editor/images";
}